<template>
  <q-card class="bg-background-light">
    <q-card-section class="q-pa-sm">
      <q-skeleton
        animation="fade"
        class="full-width"
        style="aspect-ratio: 4/3; border-radius: 14px"
      />
    </q-card-section>

    <q-card-section class="q-pb-none">
      <q-skeleton
        type="text"
        width="70%"
        class="text-subtitle1"
        animation="fade"
      />
      <q-skeleton
        type="text"
        width="30%"
        class="text-subtitle"
        animation="fade"
        style="margin-top: -4px"
      />
    </q-card-section>
    <q-card-section class="flex justify-between items-center q-pt-none q-pb-sm">
      <q-skeleton
        type="text"
        width="30%"
        class="text-subtitle1"
        animation="fade"
      />
      <q-skeleton
        type="text"
        width="20%"
        class="text-subtitle1"
        animation="fade"
      />
    </q-card-section>
    <!--<q-card-section class="q-pt-none">
      <q-skeleton animation="fade" style="height: 38px; border-radius: 28px" />
    </q-card-section>-->
  </q-card>
</template>

<script>
export default {
  name: "VehicleCardPlaceholder",
  components: {},
  props: {},
  data() {
    return {
      clickLocation: {}
    };
  },
  mounted() {},
  methods: {}
};
</script>

<style lang="scss" scoped></style>
